module.exports = __webpack_public_path__ + "static/media/screen2.4d11ddb4.png";